import React, { useState, useLayoutEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";

// import JS files
import AddProducer from "./AddProducer";
import ProducerCard from "./ProducerCard";
import useFetch from "../../../../context/useFetch";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import { fixNumbers } from "../../../../utils";

// import Others files

const Producer = (props) => {
  const [openAddProducerModal, setOpenAddProducerModal] = useState(false);
  const handleModal = () => {
    setOpenAddProducerModal((before) => !before);
  };
  const [nameFilter, setNameFilter] = useState(null);
  const [standardFilter, setstandardFilter] = useState(null);
  const [brandFilter, setbrandFilter] = useState(null);

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [brandsList, setBrandsList] = useState({ results: [] });

  const filterList = [
    {
      type: "textField",
      label_fa: "نام و نام خانوادگی",
      label_en: "fullName",
      state: nameFilter,
    },
    {
      type: "textField",
      label_fa: "کد استاندارد",
      label_en: "standard",
      state: standardFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];

  const [pageData, setPageData] = useState({ results: [] });

  const {
    formState: { errors },
  } = useForm();

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
  });

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const getProvider = useFetch({
    method: "get",
    url: "Provider_Service",
    // noHeader: true,
    params: {
      name: nameFilter,
      code: fixNumbers(standardFilter),
      brand: brandFilter,
    },
    pagination: paginationPageInfo,
    trigger: true,
    setter: setPageData,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطا در برقراری ارتباط با سرور", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "fullName") setNameFilter(e.length > 0 ? e : null);
    if (state == "standard") setstandardFilter(e.length > 0 ? e : null);
    if (state == "brand") setbrandFilter(e);
  };
  const filter = () => {
    if (
      nameFilter !== null ||
      standardFilter !== null ||
      brandFilter !== null
    ) {
      setIsFilterOn(true);
      getProvider.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    setstandardFilter(null);
    setbrandFilter(null);
    getProvider.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setPageData({ results: [] });

    getProvider.reFetch();
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="producers">
        <>
          <div className="panel-main-header">
            <span className="">مدیریت تولیدکنندگان </span>
          </div>
          <div className="add-item-container">
            <span className="text">
              برای اضافه کردن تولیدکننده جدید روی دکمه افزودن کلیک کنید.
            </span>
            <MuiButton
              onClick={handleModal}
              variant="outlined"
              icon={<AddIcon />}
              color="secondary"
              text="افزودن"
            />
          </div>
          {openAddProducerModal && (
            <AddProducer
              openModal={openAddProducerModal}
              setOpenModal={setOpenAddProducerModal}
              getFunc={getProvider}
            />
          )}

          <PanelFilter
            header="فیلتر تولیدکنندگان:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
            {pageData.results.map((item, index) => {
              return [
                <>
                  <ProducerCard
                    key={item.id}
                    name={item.name}
                    address={item.address}
                    city={item.city}
                    email={item.email}
                    phone={item.phone}
                    phone_number={item.phone_number}
                    // brand={item.brand}
                    bangle={item.bangle}
                    attach_file={item.attach_file}
                    userId={item.id}
                    user={item.user}
                    code={item.code}
                    getFunc={getProvider}
                  />
                </>,
              ];
            })}
          </div>
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default Producer;
